import { createSlice } from '@reduxjs/toolkit';
import persistReducer from 'redux-persist/es/persistReducer';
import storage from 'redux-persist/lib/storage';
import reducerTypes from '../reducerTypes';

const initialState = {
  isTokenExpired: false,
  token: null,
  licenseType: null,
  rolePermissions: null,
  isBackendAuthorized: false,
};

export const authSlice = createSlice({
  name: reducerTypes.auth,
  initialState,
  reducers: {
    SET_TOKEN_EXPIRY_STATUS: (state, data) => {
      state.isTokenExpired = data.payload;
    },
    SET_TOKEN: (state, data) => {
      state.token = data.payload;
    },
    SET_ROLE_PERMISSION: (state, data) => {
      state.rolePermissions = data.payload;
    },
    SET_IS_BACKEND_AUTHORIZED: (state, data) => {
      state.isBackendAuthorized = data.payload;
    },
    SET_LICENSE_TYPE: (state, data) => {
      state.licenseType = data.payload;
    },
    SET_LOGOUT: state => {
      state.licenseType = null;
    },
  },
});

export const {
  SET_TOKEN_EXPIRY_STATUS,
  SET_TOKEN,
  SET_LICENSE_TYPE,
  SET_ROLE_PERMISSION,
  SET_IS_BACKEND_AUTHORIZED,
  SET_LOGOUT,
} = authSlice.actions;

const authPersistConfig = {
  key: 'authLicese', // Unique key for this specific persist config
  storage,
  whitelist: ['licenseType'], // Only persist 'valueToPersist' from myFeature state
};

// Create a persisted reducer specifically for 'myFeature'
export default persistReducer(authPersistConfig, authSlice.reducer);
